<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/LeaveRequest.svg" class="h-20px w-20px mr-2" />  {{ 'MyLeaveReport' | localize}}
        </h5>
        <div *ngIf="noData" class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-3">
        <div *ngIf="!isLoading" class="row px-3">
            <div class="col-md-6 mt-4">
                <ngx-shimmer-loading [width]="'100%'" [height]="'300px'"></ngx-shimmer-loading>

            </div>

            <div class="col-md-6 mt-8">
                <div class="row">
                    <div class="col-md-12">
                        <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                    </div>
                </div>
            </div>

        </div>
        <!--Empty State UI-->
        <div *ngIf="isLoading && isEmpty">

            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-20">
                    <img src="../../../../assets/common/images/new-dashboard/leave-report-empty-ui.svg" class="img-fluid w-275px" />
                    <h6 class="text-muted mt-4 ml-20">{{ 'NoDataFounds' | localize}}</h6>
                </div>
            </div>
        </div>



        <!--Pie Chart Code Section-->
        <div *ngIf="isLoading && !isEmpty" class="row" id="leaveReports">
            <div class="col-md-5 mb-3 leaveReportsSection overflow-hidden">
                <ngx-charts-pie-chart [results]="timeDetails"
                                      [view]="view"
                                      [scheme]="colorScheme">
                    <ng-template #tooltipTemplate let-model="model">
                        <h6>
                            {{model.name  | localize}}
                        </h6>
                        <h6>{{model.value}}</h6>
                    </ng-template>
                </ngx-charts-pie-chart>

            </div>

            <div class="col-md-7">
                <div class="row mt-24">
                    <div *ngFor=" let Details of timeDetails" class="col-6 col-md-12 col-lg-6">
                        <div class="d-flex mt-5">

                                <div class="card h-100 w-35px" [ngStyle]="{'background-color': getColorForDetails(Details.name)}">
                                    <span class="mx-auto text-white">  {{Details.value}}</span>
                                </div>

                            <div class="ml-3">
                                <span *ngIf="Details.name === 'Parent leave'">{{'ParentalLeave'|localize}}</span>
                                <span *ngIf="Details.name === 'Public holiday'">{{'PublicHoliday'|localize}}</span>
                                <span *ngIf="Details.name === 'Casual Leave'">{{'Casual Leave'|localize}}</span>
                                <span *ngIf="Details.name === 'Sick'">{{'Sick'|localize}}</span>
                                <span *ngIf="Details.name === 'Unpaid leave'">{{'UnpaidLeave'|localize}}</span>
                                <span *ngIf="Details.name === 'Vacation'">{{'Vacation'|localize}} </span>
                                <!-- <span *ngIf="Details.name === 'Half day'">{{'HalfDay22'|localize}}</span> -->
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>
